import { get, post } from '@utils/request';

export const getLogisticsDetail = params => get('shop-logistics/query/logistics-detail', params);

export const getLogisticsTrace = params => get('shop-logistics/query/logistics-trace', params);

export const updateLogisticsAddress = data => post('shop-logistics/edit/logistics-adress', data);
// 物流列表
export const getUserEntityOrder = params => get('shop-logistics/query/user/entity/order', params);

export const queryUserEntityOrderGet = params => get('shop-logistics/query/user/entity/order/get', params);

// @aigc:start 2024/03/20-17:33
// 兑吧订单详情
export const queryDbOrderDetail = params => get('shop-logistics/query/user/entity/duibaorder?', params);

// @aigc:end 2024/03/20-17:33

// 获取补全地址是否需要添加老师
export const addressAfterGuide = params => get('guide/addressAfterGuide', params);

// 查询订单类型
export const queryOrderType = params => get('shop-logistics/query/entity/order/type', params);
